import { FC, useState } from 'react';
import { useMutation } from 'react-query';
import * as Yup from 'yup';
import { FormikHelpers } from 'formik';
import {
  ButtonOutlinePrimary,
  ButtonPrimary,
  Form,
  Icon,
  InputPhone,
  InputText,
  InputTextarea,
  useSnackbar
} from '@lambdacurry/component-library';
import { phoneValidation, emailAddressValidation } from 'lib/forms/validation';
import { Card, CardContent, Grid } from 'lib/components';
import { submitFormToHubspot } from '../../util/helpers/hubspot';

const validationSchema = Yup.object({
  ...phoneValidation,
  ...emailAddressValidation,
  firstName: Yup.string().required('First Name is required'),
  lastName: Yup.string().required('Last Name is required'),
  message: Yup.string().required('Please let us know how we can help')
});

const initialValues = { firstName: '', lastName: '', phone: '', email: '', message: '' };
type FormValues = typeof initialValues;

const postForm = (values: FormValues) => {
  const fields = ['firstName', 'lastName', 'phone', 'email', 'message'].map(name => ({
    objectTypeId: '0-1',
    name,
    value: values[name]
  }));

  return submitFormToHubspot('12da3dbb-ff71-4abe-adb1-65faa13be39d', fields);
};

export const SupportContactForm: FC = () => {
  const { addSnackbar } = useSnackbar();
  const [formSent, setFormSent] = useState<boolean>(false);
  const { mutate } = useMutation(postForm, {
    onSuccess: () => {
      setFormSent(true);
    },
    onError: error => {
      console.log(error);
      addSnackbar('Your email did not submit correctly.', { variant: 'error' });
    }
  });

  const handleSubmit = (values: FormValues, formikHelpers: FormikHelpers<FormValues>) => mutate(values);

  return (
    <Grid className="items-start max-h-120 mt-4">
      <Card className="col-span-12 p-4">
        <CardContent variant="slim">
          <h4>Send Us A Quick Message</h4>
          <Form<FormValues> initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
            {() => (
              <>
                <div className="sm:gap-x-6 sm:grid sm:grid-cols-2">
                  <InputText disabled={formSent} name="firstName" label="First name" />
                  <InputText disabled={formSent} name="lastName" label="Last name" />
                  <InputPhone disabled={formSent} name="phone" label="Phone number" />
                  <InputText disabled={formSent} name="email" label="Email" />
                </div>
                <InputTextarea disabled={formSent} className="mt-4" name="message" label="Message" rows={6} />
                {!formSent ? (
                  <ButtonOutlinePrimary className="mt-4 !px-12 w-full md:w-56" type="submit">
                    Submit
                  </ButtonOutlinePrimary>
                ) : (
                  <ButtonPrimary data-cy={'submit-success'} className="mt-4 w-full md:w-auto">
                    <Icon className="mr-2" name="check" /> We'll be in touch soon!
                  </ButtonPrimary>
                )}
              </>
            )}
          </Form>
        </CardContent>
      </Card>
    </Grid>
  );
};
